import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { CleanHeader } from './CleanHeader';
import { PaywallFooter } from '@/components/paywall/PaywallFooter';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  padding: 16px;
`;

const Screen = styled.div`
  max-width: 430px;
  flex: 1;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.41px;
  color: #212121;
  margin: 0 0 24px 0;
`;

interface AccountLayoutProps {
  showGear?: boolean;
  showHome?: boolean;
  showBack?: boolean;
  backText?: string;
  centerText?: string;
  title?: string;
  showLogo?: boolean;
  pageTitle?: string;
  onBack?: () => void;
  onGear?: () => void;
  children?: ReactNode;
}

export function AccountLayout({
  showGear = false,
  showHome = false,
  showBack = false,
  backText,
  centerText,
  title,
  showLogo = false,
  pageTitle,
  onBack,
  onGear,
  children,
}: AccountLayoutProps) {
  return (
    <Container>
      <CleanHeader
        showGear={showGear}
        showHome={showHome}
        showBack={showBack}
        backText={backText}
        centerText={centerText}
        title={title}
        showLogo={showLogo}
        onBack={onBack}
        onGear={onGear}
      />
      <Screen>
        {pageTitle && <PageTitle>{pageTitle}</PageTitle>}
        {children}
      </Screen>
      <PaywallFooter />
    </Container>
  );
}
